import { render, staticRenderFns } from "./ZDMFailures.vue?vue&type=template&id=5bb3b838&scoped=true&"
import script from "./ZDMFailures.vue?vue&type=script&lang=js&"
export * from "./ZDMFailures.vue?vue&type=script&lang=js&"
import style0 from "./ZDMFailures.vue?vue&type=style&index=0&id=5bb3b838&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb3b838",
  null
  
)

export default component.exports